import { React } from 'react';
import BSModal from 'react-bootstrap/Modal';
import classNames from 'classnames';

import styles from './Modal.module.scss';

const CustomHeader = ({ children, className, ...props }) => (
  <BSModal.Header className={classNames(className, styles.header)} {...props}>
    {children}
  </BSModal.Header>
);

const CustomFooter = ({ children, className, ...props }) => (
  <BSModal.Footer className={classNames(className, styles.footer)} {...props}>
    {children}
  </BSModal.Footer>
);

const Modal = BSModal;
Modal.Header = BSModal.Header;
Modal.CustomHeader = CustomHeader;
Modal.Title = BSModal.Title;
Modal.Body = BSModal.Body;
Modal.Footer = BSModal.Footer;
Modal.CustomFooter = CustomFooter;

export default Modal;
